import { render, staticRenderFns } from "./UtilityPeriodCredits.vue?vue&type=template&id=33c6845c&scoped=true&"
import script from "./UtilityPeriodCredits.vue?vue&type=script&lang=ts&"
export * from "./UtilityPeriodCredits.vue?vue&type=script&lang=ts&"
import style0 from "./UtilityPeriodCredits.vue?vue&type=style&index=0&id=33c6845c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c6845c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
